import {setLocale} from  "yup"

setLocale({
    mixed:{
        default: "Campo não é válido",
        required: "O campo é obrigatório",
    
    },
    string: {
        email: () => "O campo precisa conter um email válido",
        max: ({max}) => `O campo pode conter no máximo ${max} caracteres`,
        min: ({min}) => `O campo pode conter no mínimo ${min} caracteres`,
        length: ({length}) => `O campo precisa ter exatamente ${length} caracteres`,
    },
    date:{
        max:({max}) => `A data dever ser menor que ${max}`,
        min:({min}) => `A data dever ser maior que ${min}`,
    },
    number:{
        integer: () => "O campo precisa ter um valor inteiro",
        negative: () => "O campo precisa ter um valor inteiro",
        positive: () => "O campo precisa ter um valor inteiro",
        moreThan: ({more}) => `O campo precisa ter um valor maior que ${more}`,
        lessThan: ({less}) => `O campo precisa ter um valor menor que ${less}`,
        max: ({max}) => `O campo precisa ter um valor menos de ${max} caracteres`,
        min: ({min}) => `O campo precisa ter um valor mais de ${min} caracteres`,
    },
    boolean: {},
    object: {},
    array: {},
});